<template>
  <div class="overseaRecharge">
      <CopyDesc :title="title" :orderList='orderList'></CopyDesc>
      
      <div class="wrapp">
        <div class="titlep">{{$t('other.a2189')}}</div>
        <div class="imgbox">
            <img src="https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/8a98313674bc4f9a9afcde1b49c35611.jpg" alt="">

        </div>
      </div>

  </div>
</template>

<script>
export default {
data(){
return{
    title:this.$t('other.a1894'),
    orderList:[{
        label:this.$t('other.a2190'),
        desc:this.$t('other.a2191'),
    },{
        label:this.$t('other.a2192'),
        desc:this.$t('other.a2193'),
    },{
        label:this.$t('other.a2194'),
        desc:this.$t('other.a2195'),
    },]


}
},
components: {
  CopyDesc:() => import(`./components/copyDesc`),
  
   

},
create(){

},
methods:{

}
}

</script>
<style lang="scss" scoped>
.overseaRecharge{
    margin-bottom: 50px;
    .wrapp{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .titlep{
            font-size: 28px;
            font-weight: 600;
            margin: 50px 0 10px 0;
        }
        
    }
    .imgbox{
        width: 800px;
        height: 1200px;
        overflow: hidden;

        img{
            width: 100%;
        }
    }
}
</style>